import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const features = [
    {
      title: 'Screen Time Insights',
      description: 'See exactly how you\'re spending time online with easy-to-understand visuals and personalized insights.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    {
      title: 'AI Study Buddy',
      description: 'Our AI analyzes your habits and suggests the best study times, helping you balance social media and schoolwork.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      title: 'Goal Tracker',
      description: 'Set personal goals for gaming, social media, and YouTube time, and earn rewards as you build better habits.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      ),
    },
    {
      title: 'Mindfulness Moments',
      description: 'Take quick breaks with guided meditations and exercises designed specifically for teen brains and stress levels.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      title: 'Distraction Blocker',
      description: 'Block TikTok, Snapchat, or games during homework time, with customized schedules that work for YOUR life.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
    },
    {
      title: 'Sleep Guardian',
      description: 'Wind down before bed with reduced blue light and notifications. Our AI learns your patterns to help you sleep better.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      ),
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-purple-600 to-pink-500 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
          <div className="md:flex md:items-center md:justify-between">
            <div className="md:w-1/2 md:pr-10">
              <div className="inline-block mb-4 bg-white bg-opacity-20 rounded-lg px-3 py-1 text-sm font-bold">
                For Teens 13+
              </div>
              <h1 className="text-4xl md:text-5xl font-display font-bold leading-tight">
                Take Control of Your Screen Time
              </h1>
              <p className="mt-4 text-lg md:text-xl text-white">
                Balance social life, gaming, homework and sleep with our AI-powered Digital Wellbeing Assistant designed specifically for teens.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
                <Link to="/dashboard" className="btn bg-white text-purple-600 hover:bg-indigo-50 shadow-md">
                  Get Started
                </Link>
                <Link to="/ai-insights" className="btn border border-white text-white hover:bg-white hover:bg-opacity-10">
                  See How AI Helps
                </Link>
              </div>
            </div>
            <div className="mt-10 md:mt-0 md:w-1/2">
              <div className="relative mx-auto w-full max-w-md">
                <div className="relative rounded-2xl bg-white shadow-xl overflow-hidden">
                  <div className="h-1.5 bg-gray-200 flex">
                    <div className="w-1.5 h-1.5 rounded-full bg-red-500 ml-1.5 mt-0"></div>
                    <div className="w-1.5 h-1.5 rounded-full bg-yellow-500 ml-1"></div>
                    <div className="w-1.5 h-1.5 rounded-full bg-green-500 ml-1"></div>
                  </div>
                  <div className="p-4">
                    <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
                      <div className="text-center">
                        <div className="w-16 h-16 mx-auto rounded-full bg-purple-500 flex items-center justify-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <h3 className="mt-4 text-lg font-medium text-gray-900">Digital Balance</h3>
                        <p className="mt-1 text-sm text-gray-500">Your phone, your control</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-display font-bold text-gray-900">How It Works</h2>
            <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
              Tools designed specifically for teen life and the way YOU use technology.
            </p>
          </div>

          <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="card hover:shadow-lg transition-shadow duration-300"
              >
                <div className="h-12 w-12 rounded-md bg-purple-100 flex items-center justify-center text-purple-500">
                  {feature.icon}
                </div>
                <h3 className="mt-4 text-xl font-medium text-gray-900">{feature.title}</h3>
                <p className="mt-2 text-base text-gray-500">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI Features Section */}
      <section className="py-16 bg-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:flex lg:items-center lg:justify-between">
            <div className="lg:w-1/2 lg:pr-10">
              <h2 className="text-3xl font-display font-bold text-gray-900">AI That Actually Gets You</h2>
              <p className="mt-4 text-lg text-gray-600">
                Our AI doesn't just track your screen time – it understands your specific challenges as a teen and helps solve them.
              </p>
              
              <div className="mt-8 space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-md bg-purple-100 flex items-center justify-center text-purple-600">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">Personal Pattern Recognition</h3>
                    <p className="mt-2 text-base text-gray-500">
                      Our AI learns when you\'re most distracted vs. focused and helps you create a schedule that actually works.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-md bg-purple-100 flex items-center justify-center text-purple-600">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">School-Life Balance Predictions</h3>
                    <p className="mt-2 text-base text-gray-500">
                      See how your current habits will affect your study time, sleep, and stress levels in the coming week.
                    </p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="h-10 w-10 rounded-md bg-purple-100 flex items-center justify-center text-purple-600">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">App-Specific Insights</h3>
                    <p className="mt-2 text-base text-gray-500">
                      Find out which apps are really draining your time and mood, with specific recommendations for each one.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-10">
                <Link
                  to="/ai-insights"
                  className="btn bg-purple-600 text-white hover:bg-purple-700"
                >
                  Explore AI Features
                </Link>
              </div>
            </div>
            
            <div className="mt-10 lg:mt-0 lg:w-1/2 lg:pl-10">
              <div className="relative mx-auto rounded-xl shadow-xl overflow-hidden max-w-md">
                <img 
                  src="https://images.unsplash.com/photo-1611262588024-d12430b98920?ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80" 
                  alt="Teen using smartphone"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-purple-900 to-transparent opacity-70"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="bg-white bg-opacity-90 rounded-lg p-4 shadow-lg">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-purple-500 flex items-center justify-center text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <div className="text-sm font-medium text-gray-500">AI Recommendation</div>
                        <div className="text-base font-medium text-gray-900">TikTok breaks during homework improve focus if limited to 5 minutes</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-display font-bold text-gray-900">What Teens Say</h2>
            <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
              Hear from others who've taken control of their digital life.
            </p>
          </div>
          
          <div className="mt-12 grid gap-8 md:grid-cols-3">
            <div className="bg-gray-50 rounded-lg p-6">
              <div className="flex items-center mb-4">
                <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold">
                  JT
                </div>
                <div className="ml-4">
                  <h4 className="font-medium">Jordan T.</h4>
                  <p className="text-sm text-gray-500">15 years old</p>
                </div>
              </div>
              <p className="text-gray-600">
                "The AI totally gets when I need to focus on homework vs. when I'm just chilling. It's like having a coach who actually understands my life as a student."
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <div className="flex items-center mb-4">
                <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                  AT
                </div>
                <div className="ml-4">
                  <h4 className="font-medium">Alex T.</h4>
                  <p className="text-sm text-gray-500">16 years old</p>
                </div>
              </div>
              <p className="text-gray-600">
                "I was spending 5+ hours on social media daily without realizing it. The app helped me cut back to 2 hours and now I actually have time for basketball again."
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6">
              <div className="flex items-center mb-4">
                <div className="h-12 w-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 font-bold">
                  MC
                </div>
                <div className="ml-4">
                  <h4 className="font-medium">Morgan C.</h4>
                  <p className="text-sm text-gray-500">14 years old</p>
                </div>
              </div>
              <p className="text-gray-600">
                "The sleep guardian feature helped me realize why I was so tired all day. Now I stop using my phone an hour before bed and I'm actually awake in class."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl shadow-xl overflow-hidden">
            <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
              <div className="lg:self-center lg:max-w-3xl">
                <h2 className="text-3xl font-display font-bold text-white sm:text-4xl">
                  <span className="block">Ready to take control of your screen time?</span>
                </h2>
                <p className="mt-4 text-lg leading-6 text-indigo-100">
                  Join thousands of teens who are finding balance between social media, gaming, school, and sleep. No lectures, just tools that actually help.
                </p>
                <Link
                  to="/dashboard"
                  className="mt-8 bg-white border border-transparent rounded-md shadow px-6 py-3 inline-flex items-center text-base font-medium text-purple-600 hover:bg-indigo-50"
                >
                  Get Started (It's Free!)
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage; 